import { memo, useMemo } from 'react';
import { usePrevious } from '@namespace/helpers';
import { useI18n } from '@namespace/i18n';
import { COLUMN_TYPES } from '../../../../constants';
import {
  EVENT_RESULT_PENALTY,
  TOTAL_SCOPE_ID_BY_SPORT,
  TOTAL_SYMBOL_BY_SPORT
} from '../../constants';
import ScoreDetails from '../../Details';
import { SportCommonProps } from '../../types';
import {
  calculateFormattedPenaltyScore,
  calculatePenaltyScore,
  getEventValues
} from '../../utils';

const BeachFootball = ({
  sportId,
  eventResultId,
  byResultType = [],
  total,
  isShortVersion,
  lineView
}: SportCommonProps) => {
  const { t } = useI18n();

  const previousByResultType = usePrevious(byResultType);
  let penaltyScore = null;
  let totalPenaltyScore = null;

  if (
    byResultType &&
    eventResultId === EVENT_RESULT_PENALTY &&
    byResultType.some(({ resultTypeData, resultTypeId }) =>
      resultTypeId === EVENT_RESULT_PENALTY
        ? resultTypeData.every(
            (data) => data.number && data.scopeId && data.value
          )
        : false
    )
  ) {
    [penaltyScore, totalPenaltyScore] = calculatePenaltyScore(
      byResultType,
      eventResultId
    );
  } else if (
    byResultType &&
    eventResultId === EVENT_RESULT_PENALTY &&
    previousByResultType
  ) {
    [penaltyScore, totalPenaltyScore] = calculatePenaltyScore(
      previousByResultType,
      eventResultId
    );
  }

  const commonScoreTotalData = useMemo(
    () => ({
      type: COLUMN_TYPES.TOTAL,
      tag: t(TOTAL_SYMBOL_BY_SPORT.default),
      scores: getEventValues(total, TOTAL_SCOPE_ID_BY_SPORT[sportId])
    }),
    [sportId, t, total]
  );

  const calculatedFullFormattedScore = useMemo(
    () =>
      calculateFormattedPenaltyScore({
        byResultType,
        commonScoreTotalData,
        eventResultId,
        isShortVersion,
        penaltyScore,
        sportId,
        totalPenaltyScore
      }),
    [
      byResultType,
      commonScoreTotalData,
      eventResultId,
      isShortVersion,
      penaltyScore,
      sportId,
      totalPenaltyScore
    ]
  );

  return (
    <ScoreDetails
      scoreData={calculatedFullFormattedScore}
      isShortVersion={isShortVersion}
      lineView={lineView}
    />
  );
};

export default memo(BeachFootball);
